import { render, staticRenderFns } from "./BookingPayment.vue?vue&type=template&id=09556d94"
import script from "./BookingPayment.vue?vue&type=script&lang=js"
export * from "./BookingPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports